/**
 * Four-pip brand mark — clubs/spades use true black inks like `PlayingCard`;
 * hearts/diamonds red to match table cards.
 */
export function SetbackMark({ className = "" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-label="Setback"
    >
      <rect width="48" height="48" rx="10" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.12)" strokeWidth="1" />
      <g
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize={17}
        fontWeight={700}
        textAnchor="middle"
        dominantBaseline="central"
      >
        <text x="17" y="19" fill="#0a0a0a">{"\u2660"}</text>
        <text x={31} y="19" fill="#0a0a0a">{"\u2663"}</text>
        <text x="17" y={35} fill="#dc2626">{"\u2665"}</text>
        <text x={31} y={35} fill="#dc2626">{"\u2666"}</text>
      </g>
    </svg>
  );
}
